import { CommonModule } from '@angular/common';
import { Component, OnInit, Optional } from '@angular/core';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'xcdrs-subgroup-proceed-dialog',
  standalone: true,
  imports: [CommonModule, MatButtonModule, TranslateModule],
  templateUrl: './subgroup-proceed-dialog.component.html',
  styleUrl: './subgroup-proceed-dialog.component.scss'
})
export class SubgroupProceedDialogComponent implements OnInit {

  constructor(
    @Optional() public dialogRef: MatDialogRef<SubgroupProceedDialogComponent>,
  ) { }

  ngOnInit(): void {

  }

  onClick(){
    this.dialogRef.close();
  }
}
